import { Card, Divider, Typography } from "antd";
import React from "react";
import { formatDateByType } from "../../libs/utils";
import { PAYMENT_KEYS, RECEIPT_KEYS } from "../../modules/PendingApprovalRequets/api/constants";
import { approvalCardStyles } from "./style/style";
import type { ApprovalCardProps } from "./types";

const { Text } = Typography;

/**
 * ApprovalCard Component
 */

const ApprovalCard: React.FC<ApprovalCardProps> = ({ isReceiptModuleEnabled, item }) => {
  const goToDetails = (item: ApprovalCardProps["item"]) => {
    const { leaseId, titleKey, pdcId, paymentReceiptId } = item;

    if (leaseId && titleKey === "settlementApproval") {
      return window.open(`/move-out/summery/${leaseId}`, "_blank");
    }

    if (titleKey && PAYMENT_KEYS.includes(titleKey)) {
      if (isReceiptModuleEnabled && RECEIPT_KEYS.includes(titleKey)) {
        return window.open(`/receipts?paymentReceiptId=${paymentReceiptId}`, "_blank");

        //  return window.open(
        //    `/receipts?paymentReceiptId=paymentReceiptId-2e0e671e-cc39-4575-a6b8-5fa6ac4204a6`,
        //    "_blank",
        //  );
      }

      return window.open(`/invoicing?pdcId=${pdcId}`, "_blank");
    }

    if (titleKey === "paymentPlanApproval" && leaseId) {
      return window.open(`/newbookingform/${leaseId}`, "_blank");
    }

    if (leaseId) {
      return window.open(`/viewbookingform/${leaseId}`, "_blank");
    }
  };

  const row = (label: string, value: string) => (
    <div style={approvalCardStyles.row}>
      <Text style={approvalCardStyles.rowLabel}>{label}</Text>
      <span style={approvalCardStyles.rowValue}>{value}</span>
    </div>
  );

  return (
    <Card bordered={true} style={approvalCardStyles.card} bodyStyle={approvalCardStyles.body}>
      {row("Unit Details:", item.unitDetails)}
      {row("Tenant Name:", item.tenantName)}
      {row("Requested By:", item.requestedBy)}
      {row("Requested On:", formatDateByType(item?.date, "datetime") || "")}

      <Divider style={approvalCardStyles.divider} />
      <div style={approvalCardStyles.footer}>
        <span style={approvalCardStyles.footerText} onClick={() => goToDetails(item)}>
          View Details/Approve
        </span>
      </div>
    </Card>
  );
};

export default ApprovalCard;
